import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

const StyledDialog = styled(Dialog)`
  min-width: ${(props) => props.width || 'auto'};
  z-index: 99000;

  .MuiBackdrop-root {
    backdrop-filter: blur(32px);
    background-color: ${COLOR.colorGrayV2};
  }

  .MuiDialog-paper {
    max-width: 800px;
    border-radius: 24px;
  }

  .dialog-wrapper {
    display: flex;
    flex-direction: column;
    padding: 24px;
    gap: 16px;
    height: auto;

    .dialog-logo {
      margin-bottom: 4px;
    }

    .new-dialog-title {
      font-weight: 510;
      font-size: 24px;
      line-height: 32px;
      color: ${COLOR.black.default};
      text-transform: uppercase;
      word-wrap: break-word;
    }

    .dialog-title {
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      color: ${COLOR.black.default};
      text-transform: uppercase;
    }

    .dialog-content {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: #1c1c1e;
      overflow-y: auto;
      scrollbar-width: thin;
      &::-webkit-scrollbar {
        width: 2px;
      }
      &::-webkit-scrollbar-track {
        background: ${COLOR.white};
      }
      &::-webkit-scrollbar-thumb {
        background: ${COLOR.subText};
        border-radius: 100px;
        border: 1px solid ${COLOR.subText};
      }
    }

    .dialog-action {
      margin-left: auto;
      margin-bottom: 0;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .logo-img {
      height: 32px;
    }

    .dialog-wrapper {
      .dialog-content {
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
      }
    }
  }
`;
export { StyledDialog };
